import upperFirst from 'lodash/upperFirst';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Reaction } from 'api/conversations/types';
import { MessageReactionAdded } from 'api/notifications/meta';
import { Tag } from 'components/atoms/tag';
import { UserMessageReply } from 'components/molecules/user-message-reply';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const MessageReactionAddedView: FC<{ meta: MessageReactionAdded }> = ({
  meta: {
    message: { content },
    reaction,
  },
}) => {
  return (
    <Container>
      <UserMessageReply content={content} showReplyTo={false} />
      <Tag color="cool-gray">{Reaction[upperFirst(reaction)]}</Tag>
    </Container>
  );
};
